import React, { useEffect, useMemo } from "react";
import { useExpectationSettings } from "./store";
import { fourPlaceHolder } from "modules/utilities/utility";
import NoData from "assets/svgs/no_data/NoData";
import SoftBadge from "modules/common/SoftBadge";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import AdvanceTable from "modules/common/advance-table/AdvanceTable";

function ExpectationSettings({ case_id }) {
  const { expectationData, expectationLoading, fetchExpectationData } =
    useExpectationSettings();

  useEffect(() => {
    fetchExpectationData(case_id);
  }, [case_id]);

  const tableData = useMemo(() => {
    return (expectationData?.monthsDetails?.monthExpectations||[])?.map((item) => {
      return {
        month: item?.month,
        goal: item?.goal,
        description: item?.description,
      };
    });
  }, [expectationData]);

  const columns = [
    {
      accessor: "month",
      Header: "Month",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "goal",
      Header: "Goal",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "description",
      Header: "description",
      headerProps: { className: "text-900" },
      Cell: rowData => {
        const { description } = rowData.row.original
        return(
          <div className="text-wrap text-break">
            {description}
          </div>
        )
      }
  
    },
  ];

  return (
    <div className="mt-n2">
      <div className="py-2">
        Expectation Settings:{" "}
        <SoftBadge bg="info" className="me-2 fw-bold">
          <span style={{ fontSize: "14px" }}>
            {expectationData?.monthsDetails?.months} month
          </span>
        </SoftBadge>
      </div>
      <div>
        <div>
          <div
            style={{
              maxHeight: "10rem",
              minHeight: "5rem",
              overflowY: "scroll",
            }}
            className=" px-3 scrollable-container grid-container"
          >
            {expectationData?.monthsDetails?.cardDetails?.componentDetails?.map(
              (response) => {
                return (
                  <div
                    key={response?.title}
                    className="border rounded my-2 shadow"
                    style={{ padding: "1rem" }}
                  >
                    <p className="m-0 p-2 border-bottom">{response?.title}</p>
                    <p className="m-0 p-2 text-success">
                      {response?.description}
                    </p>
                  </div>
                );
              }
            )}
          </div>
        </div>

        <div>
          <div
            className="mt-1 shadow rounded mt-2 scrollable-container mx-3"
            style={{ maxHeight: "19vh", overflowY: "scroll" }}
          >
            {expectationLoading ? (
              fourPlaceHolder()
            ) : expectationData?.monthsDetails?.monthExpectations &&
              expectationData?.monthsDetails?.monthExpectations?.length ? (
              <AdvanceTableWrapper columns={columns} data={tableData}>
                <AdvanceTable
                  table
                  headerClassName="bg-200 text-nowrap align-middle"
                  rowClassName="align-middle white-space-nowrap"
                  tableProps={{
                    bordered: true,
                    striped: true,
                    className: "fs-10 mb-0 overflow-hidden",
                  }}
                />
              </AdvanceTableWrapper>
            ) : (
              <div className="p-3 bg-white rounded-bottom text-center">
                No Data Available <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExpectationSettings;